import React, { useState } from 'react';
import { createDesignation } from './services/api';
import { useNavigate } from 'react-router-dom';

const userTypes = [
  { value: 'SUPER_ADMIN', label: 'Super Admin' },
  { value: 'ADMIN', label: 'Admin' },
  { value: 'SUPERVISOR', label: 'Supervisor' },
  { value: 'USER', label: 'User' },
];

const CreateDesignation: React.FC = () => {
  const [name, setName] = useState('');
  const [userType, setUserType] = useState('ADMIN');
  const [remoteCheckin, setRemoteCheckin] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(false);
    try {
      await createDesignation({ name, user_type: userType, remote_checkin: remoteCheckin });
      setSuccess(true);
      setTimeout(() => navigate('/designations'), 1200);
    } catch (err) {
      setError('Failed to create designation');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container py-4" style={{ maxWidth: 500 }}>
      <h2 className="mb-4">Create Designation</h2>
      <form onSubmit={handleSubmit} className="bg-white p-4 rounded shadow-sm border">
        <div className="mb-3">
          <label className="form-label">Name</label>
          <input
            type="text"
            className="form-control"
            value={name}
            onChange={e => setName(e.target.value)}
            required
            maxLength={50}
            placeholder="Enter designation name"
          />
        </div>
        <div className="mb-3">
          <label className="form-label">User Type</label>
          <select
            className="form-select"
            value={userType}
            onChange={e => setUserType(e.target.value)}
            required
          >
            {userTypes.map(opt => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </select>
        </div>
        <div className="form-check mb-4">
          <input
            className="form-check-input"
            type="checkbox"
            id="remoteCheckin"
            checked={remoteCheckin}
            onChange={e => setRemoteCheckin(e.target.checked)}
          />
          <label className="form-check-label" htmlFor="remoteCheckin">
            Remote Check-in
          </label>
        </div>
        {error && <div className="alert alert-danger">{error}</div>}
        {success && <div className="alert alert-success">Designation created!</div>}
        <div className="d-flex justify-content-between">
          <button type="button" className="btn btn-secondary" onClick={() => navigate('/designations')} disabled={loading}>
            Back to List
          </button>
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Creating...' : 'Create Designation'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateDesignation; 